import {DataLine} from './data-line.model';

export class DataModel {

	protected dataPoints : Array<DataLine>;

    protected label : Array<string>;
    protected canvas : HTMLCanvasElement;
    protected renderer : CanvasRenderingContext2D;

    public constructor(canvas: HTMLCanvasElement) {
		this.dataPoints = [];
		this.label = [];

		this.canvas = canvas;
		this.renderer = canvas.getContext('2d');
	}

	public appendLabel(label: string[]) : DataModel
	{
        label.forEach((value) => {
        	this.label.push(value);
		});

		return this;
	}

	public appendData(data : number[], color: string, background: boolean = false) : DataModel
	{
		this.dataPoints.push(new DataLine(data, color, background));
		return this;
	}

	private createGradient(obj : DataLine) : CanvasGradient | string
	{
		let gradientColors = obj.calculateGradient();

		if(!gradientColors || gradientColors.length != 2)
			return null;

		let gradient = this.renderer.createLinearGradient(0, 0, 0, this.canvas.height);
		gradient.addColorStop(0, gradientColors[0]);
		gradient.addColorStop(1, gradientColors[1]);

		return gradient;
	}
	public toJSON(additionalData : any = '') : any
	{
		let size : number = this.label.length;

		// Prepend JSON Start
		let json = {
			labels: this.label,
			datasets: []
		};

		this.dataPoints.forEach((value) =>
		{
			let gradient = this.createGradient(value);

			let background : string | CanvasGradient = value.background;

			if(gradient)
                background = gradient;

			json.datasets.push({...{
				data: value.value,
				borderColor: value.color,
				backgroundColor: background,
				fill: value.fill
			}, ...additionalData.datasets});

		});

        return json;
	}

}



// WEBPACK FOOTER //
// ./src/app/components/charts/chart/model/base/data.model.ts